import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import classes from './MainMenu.module.css';

import CategoryTab from '../CategoryTab/CategoryTab';


class MainMenu extends Component{
    componentDidMount() {
        this.props.resetFilter();
        window.scrollTo(0, 0);
    }
    
    render() {
        return(
            <div className={classes.Menu}>
                <h2>ΤΙΜΟΚΑΤΑΛΟΓΟΣ</h2>
                <div className={classes.MenuGrid}>            
                    {this.props.categories.map(c => <CategoryTab key={c.id} name={c.name[0]} img={c.img} category={c.id}/>)}
                </div>

                <div className={classes.PartyBtn} >
                    <Link to='/Party'>
                        Τιμοκατάλογος Party
                    </Link>
                </div>   
            </div>
        )
    }
}

export default MainMenu;
